import { useAppState } from '../../client/providers/AppProvider';
import React from 'react';
import { NeedsOnboardingInformation, usePageRequireAuth } from '../../client/hooks';
import { DashboardFullPageLoading } from '../../components/common/GenericFullPageLoading';
import { DashboardLayout } from '../../components/common/layout/DashboardLayout';
import { CollegeMyProfile } from '../../components/dashboard/my-profile/CollegeMyProfile';
import { PlayerMyProfile } from '../../components/dashboard/my-profile/PlayerMyProfile';
import { Espin_Role_Enum } from '../../generated/spin-graphql';
import { ParentMyProfile } from '../../components/dashboard/my-profile/parents/ParentMyProfile';
import { HighSchoolMyProfile } from '../../components/dashboard/my-profile/HighSchoolMyProfile';

export default function MyProfilePage() {
    const { user } = useAppState();
    usePageRequireAuth({});
    if (!!!user) {
        return <DashboardFullPageLoading />;
    }

    return (
        <DashboardLayout pageTitle={'My Profile'}>
            <NeedsOnboardingInformation>
                {user.role === Espin_Role_Enum.EspinCollegeUser && <CollegeMyProfile user={user} />}
                {user.role === Espin_Role_Enum.EspinPlayerUser && <PlayerMyProfile user={user} />}
                {user.role === Espin_Role_Enum.EspinParentUser && <ParentMyProfile user={user} />}
                {user.role === Espin_Role_Enum.EspinHighschoolUser && <HighSchoolMyProfile user={user} />}
            </NeedsOnboardingInformation>
        </DashboardLayout>
    );
}
